import { render, staticRenderFns } from "./BasePicture.vue?vue&type=template&id=62e131f1&scoped=true&"
import script from "./BasePicture.vue?vue&type=script&lang=js&"
export * from "./BasePicture.vue?vue&type=script&lang=js&"
import style0 from "./BasePicture.vue?vue&type=style&index=0&id=62e131f1&lang=scss&scoped=true&"
import style1 from "./BasePicture.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e131f1",
  null
  
)

component.options.__file = "BasePicture.vue"
export default component.exports